import { zodResolver } from "@hookform/resolvers/zod";
import { forgotPasswordRequestSchema } from "@station/contracts";
import { Alert, Button, FormField, Input } from "@station/ui";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { AuthLayout } from "../components/auth-layout.js";
import { api } from "../lib/api.js";
import { errorMessage } from "../lib/errors.js";

export const Route = createFileRoute("/parola-unuttum")({ component: ForgotPasswordPage });

function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [sent, setSent] = useState(false);
  const [formError, setFormError] = useState<string | null>(null);
  const form = useForm<{ email: string }>({
    resolver: zodResolver(forgotPasswordRequestSchema),
    defaultValues: { email: "" },
  });

  const submit = form.handleSubmit(async (values) => {
    setFormError(null);
    try {
      await api.POST("/auth/password/forgot", { body: values });
      setSent(true);
    } catch (error) {
      setFormError(errorMessage(error));
    }
  });

  return (
    <AuthLayout
      title={t("auth.forgot.title")}
      description={t("auth.forgot.description")}
      footer={
        <Link to="/giris" className="text-primary hover:underline">
          {t("auth.backToLogin")}
        </Link>
      }
    >
      {sent ? (
        // Hesap olsa da olmasa da aynı ileti: hesap varlığı sızdırılmaz.
        <Alert tone="success" title={t("auth.forgot.sentTitle")}>
          {t("auth.forgot.sentDescription")}
        </Alert>
      ) : (
        <form onSubmit={(event) => void submit(event)} className="grid gap-4" noValidate>
          {formError ? <Alert tone="danger">{formError}</Alert> : null}
          <FormField label={t("auth.email")} error={form.formState.errors.email?.message} required>
            {(control) => (
              <Input
                {...control}
                {...form.register("email")}
                type="email"
                autoComplete="username"
                autoFocus
              />
            )}
          </FormField>
          <Button type="submit" loading={form.formState.isSubmitting}>
            {t("auth.forgot.submit")}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
